module.exports = __webpack_public_path__ + "img/beer_id-57.67d0a2dd.png";